import ConnectedSnackbar from 'components/ConnectedSnackbar'
import Loader from 'components/SimpleLoader'
import { GOOGLE_CAPTCHA_SITE_KEY, SIGNUP_UI_CONFIG_URL } from 'config'
import { useEffect, useReducer } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Outlet } from 'react-router'
import styles from './Signup.pcss'
import { initialState } from './state'
import { setDefaultViewConfig, updateViewConfig } from './state/actions'
import { SignupContext } from './state/context'
import { reducer } from './state/reducer'

export function Signup() {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    fetch(`${SIGNUP_UI_CONFIG_URL}?v=${Date.now()}`)
      .then(response => response.json())
      .then(config => {
        dispatch(updateViewConfig(config))
      })
      .catch(() => {
        dispatch(setDefaultViewConfig())
      })
  }, [])
  
  return (
    <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_CAPTCHA_SITE_KEY}>
      <SignupContext.Provider value={[state, dispatch]}>
        <section className={styles.wrapper}>
          <div className={styles.content}>
            {state.isLoadingConfig ? <Loader /> : <Outlet />}
          </div>
          <ConnectedSnackbar />
        </section>
      </SignupContext.Provider>
    </GoogleReCaptchaProvider>
  )
}

export default Signup
